"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
/**
 * Compares the two incoming dates from the server.
 *
 * @param dateA - First date provided by the backend
 * @param dateB - Second date provided by the backend
 */
function areServerDatesEqual(dateA, dateB) {
    try {
        var formattedA = date_fns_1.format(new Date(dateA), 'dd/MM/yyyy');
        var formattedB = date_fns_1.format(new Date(dateB), 'dd/MM/yyyy');
        return formattedA === formattedB;
    }
    catch (e) {
        return false;
    }
}
exports.default = areServerDatesEqual;
//# sourceMappingURL=areServerDatesEqual.js.map